import Vue from 'vue';

import { Eモニタリング業績予測基準値 } from '@/openapi/enum';

import Cモニタリング業績予測基準値Select from '@/components/モニタリング業績予測基準値Select/モニタリング業績予測基準値Select.vue';

import 業績予測Service from '@/classes/service/モニタリング/業績予測Service';

type State = {
  vモニタリング業績予測基準値: Eモニタリング業績予測基準値;
  readonlyMonthIndex: number | null;
};

const state = Vue.observable<State>({
  vモニタリング業績予測基準値: Eモニタリング業績予測基準値.前期,
  readonlyMonthIndex: null,
});

export default Vue.extend({
  name: 'M業績予測Mixin',

  components: {
    Cモニタリング業績予測基準値Select,
  },

  computed: {
    vモニタリング業績予測基準値: {
      get(): number {
        return state.vモニタリング業績予測基準値;
      },
      set(v: number): void {
        state.vモニタリング業績予測基準値 = v;
      },
    },
    readonlyMonthIndex(): number | null {
      return state.readonlyMonthIndex;
    },
  },

  methods: {
    setReadonlyMonthIndex(): void {
      state.readonlyMonthIndex = 業績予測Service.getReadonlyMonthIndex();
    },
  },
});
